export default {
    name: 'aboutUsAboutSection',
    title: 'About Us Section',
    type: 'document',
    fields: [
        { name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required() },
        { name: 'description', title: 'Description', type: 'array', of: [{ type: 'block' }], validation: Rule => Rule.required() }
    ],
    preview: {
        select: {
            title: 'title',
            description: 'description'
        },
        prepare(selection) {
            const { title, description } = selection;
            return {
                title,
                subtitle: description.length > 0 ? description[0].children[0].text : 'No description'
            };
        }
    }
} 